import androidDeviceMap from './androidDeviceMap.json';
import iosDeviceMap from './iosDeviceMap.json';

/**
 * Returns a friendly name for a device based on its platform and device ID
 * @param {string} os - Device operating system
 * @param {string} deviceId - Device ID
 * @returns {string} Friendly device name
 */
const getDeviceFriendlyName = (os, deviceId) => {
  if (!os || !deviceId) {
    return 'Unknown Device';
  }

  if (os.toLowerCase() === 'ios') {
    return `${iosDeviceMap[deviceId] || deviceId} - iOS`;
  }
  if (os.toLowerCase() === 'android') {
    return `${androidDeviceMap[deviceId] || deviceId} - Android`;
  }

  let platform = os;
  if (os === 'MacIntel') {
    platform = 'Mac OS';
  }

  let deviceName = deviceId.substring(0, 10);

  // For web browsers
  const [match, browserName, majorVersion] =
    deviceId.match(/(Safari|Chrome|Firefox|Edge)\/(\d+)/) || [];
  if (match) {
    deviceName = `${browserName} ${majorVersion}`;
  }

  return `${deviceName} - ${platform}`;
};

export default getDeviceFriendlyName;
